/* bambusa-devis-panier.js — bouton « Enregistrer comme devis » (Bambusa)
   ------------------------------------------------------------------
   POURQUOI CE FICHIER EXISTE
   Le moteur (bambusa-espace.js) contient aussi une fonction qui pose ce
   bouton, mais son sélecteur d'ancre attrapait le bouton « Commander »
   du TIROIR panier (#CartDrawer, rendu plus haut dans le document et
   masqué) au lieu de celui de la page panier : le bouton existait dans
   le DOM mais restait invisible. Constaté en vrai le 04/08/2026.

   Ce fichier est chargé AVANT le moteur et pose le bouton au bon
   endroit ; le moteur voit alors #bw-cart-devis déjà présent et sort
   immédiatement (son propre garde s'en charge). Aucun doublon.

   À FAIRE au lot L2, quand le moteur sera rouvert pour la synchro
   compte : supprimer initPanier() de bambusa-espace.js et ne garder que
   ce fichier.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (window.__bwCartDevis) return;
  window.__bwCartDevis = true;

  var ID = 'bw-cart-devis';

  function dateFr(ts) {
    return new Date(ts).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toast(m) { if (window.bwToast) window.bwToast(m); }

  /* L'ancre doit être celle de la PAGE panier. On exclut explicitement le
     tiroir : #CartPageForm d'abord, puis le formulaire data-location="page",
     et en dernier recours n'importe quel bouton de paiement hors #CartDrawer. */
  function ancrePage() {
    var a = document.querySelector('#CartPageForm [name="checkout"]') ||
            document.querySelector('form[data-location="page"] [name="checkout"]') ||
            document.querySelector('form[data-location="page"] .cart__checkout');
    if (a) return a;
    var tous = document.querySelectorAll('[name="checkout"], .cart__checkout');
    for (var i = 0; i < tous.length; i++) {
      if (!tous[i].closest('#CartDrawer')) return tous[i];
    }
    return null;
  }

  function poser() {
    if (!document.body.classList.contains('template-cart')) return;

    var existant = document.getElementById(ID);
    var ancre = ancrePage();
    if (!ancre) return;

    /* Le panier Impulse se re-rend en AJAX : si le bouton a été emporté,
       ou s'il a atterri ailleurs, on le repose au bon endroit. */
    var cible = ancre.closest('.cart__checkout-wrapper') || ancre.parentNode;
    if (existant) {
      if (cible.contains(existant)) return;
      existant.remove();
    }

    var wrap = document.createElement('div');
    wrap.id = ID;
    wrap.className = 'be';
    wrap.innerHTML = '<button class="be__btn be__btn--sec be__btn--large" type="button" data-ouvrir-form>' +
      'Enregistrer comme devis</button>';
    cible.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-ouvrir-form]')) {
        var validite = (window.BW_CONF || {}).validite || 30;
        wrap.innerHTML =
          '<div class="be__form">' +
            '<div class="be__form-row">' +
              '<div><label for="bw-nom">Nom de votre projet</label>' +
              '<input id="bw-nom" type="text" value="Mon projet du ' + dateFr(Date.now()) + '" maxlength="70"></div>' +
              '<div><label for="bw-cp">Code postal (facultatif)</label>' +
              '<input id="bw-cp" type="text" inputmode="numeric" maxlength="5" placeholder="30900"></div>' +
            '</div>' +
            '<label for="bw-note">Note (facultatif)</label>' +
            '<textarea id="bw-note" rows="2" placeholder="Livraison souhaitée en novembre…"></textarea>' +
            '<div class="be__actions" style="margin-top:0">' +
              '<button class="be__btn be__btn--or" type="button" data-creer>Enregistrer le devis</button>' +
              '<button class="be__btn be__btn--sec" type="button" data-fermer>Annuler</button>' +
            '</div>' +
            '<p class="be__note" style="margin-bottom:0">Votre panier reste intact. ' +
            'Le devis fige les prix et les quantités du jour, et reste valable ' + validite + ' jours.</p>' +
          '</div>';
        return;
      }

      if (e.target.closest('[data-fermer]')) { wrap.remove(); poser(); return; }

      var creer = e.target.closest('[data-creer]');
      if (!creer) return;

      var E = window.BambusaEspace;
      if (!E) { toast('Module devis indisponible — rechargez la page.'); return; }

      creer.disabled = true;
      creer.textContent = 'Enregistrement…';
      E.depuisPanier(
        (document.getElementById('bw-nom') || {}).value ? document.getElementById('bw-nom').value.trim() : '',
        (document.getElementById('bw-cp') || {}).value ? document.getElementById('bw-cp').value.trim() : '',
        (document.getElementById('bw-note') || {}).value ? document.getElementById('bw-note').value.trim() : ''
      ).then(function (devis) {
        if (!devis) { creer.disabled = false; creer.textContent = 'Enregistrer le devis'; return; }
        var url = ((window.BW_CONF || {}).urlDevis || '/pages/mes-devis') + '?d=' + devis.id;
        wrap.innerHTML = '<div class="be__bandeau be__bandeau--ok" style="margin:0">' +
          '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M4.4 12.6c1.8 1.4 3.4 3.1 4.8 5 3-4.6 6.4-8.5 10.4-11.8"/></g></svg> Devis <strong>' + esc(devis.num) + '</strong> enregistré. Votre panier est inchangé.</span>' +
          '<a class="be__btn be__btn--min be__btn--or" href="' + url + '">Voir mes devis</a></div>';
      }).catch(function (err) {
        creer.disabled = false;
        creer.textContent = 'Enregistrer le devis';
        toast(err && err.message === 'panier-vide' ? 'Votre panier est vide.' : 'Enregistrement impossible — réessayez.');
      });
    });
  }

  function boot() { setTimeout(poser, 0); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('cart:updated', function () { setTimeout(poser, 80); });
  document.addEventListener('cart:build', function () { setTimeout(poser, 80); });
}());
